import PropTypes from 'prop-types';
import React from 'react';
import PromptModal from '../components/PromptModal';

const LogoutModal = (props) => (
    props.isLogoutModalVisible
        && (
            <PromptModal
                message="Are you sure you want to log out?"
                onConfirm={props.logUserOut}
                onCancel={props.hideModal}
            />
        )
);

LogoutModal.propTypes = {
    isLogoutModalVisible: PropTypes.bool,
    hideModal: PropTypes.func.isRequired,
    logUserOut: PropTypes.func.isRequired,
};

LogoutModal.defaultProps = {
    isLogoutModalVisible: false,
};

export default LogoutModal;
